module.exports = __webpack_public_path__ + "img/sending_5.77921c9d.png";